import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import {
	SelectSchemaValid,
	SelectOptionIsValid,
} from '../validations/locationIsValid';
type Location = {
	value?: {
		id?: string | undefined;
        name?: string | undefined;
        method?: string | undefined;
    }[];
	'meta-key'?: string | undefined;
	id?: string | undefined;

	country?: string | undefined;
	city?: string | undefined;
	lat?: string | undefined;
	lng?: string | undefined;
  }
type State = {
	Selected: SelectOptionIsValid;
	oaac: SelectOptionIsValid;
	mncm: SelectOptionIsValid;
	mfc: SelectOptionIsValid;
	hlm: SelectOptionIsValid;
	customLocationSelected: Location;
	OnSelect: SelectOptionIsValid;
	month: SelectOptionIsValid;
	mcMode: SelectSchemaValid;
	asrCal: SelectSchemaValid;
	highLittude: SelectSchemaValid;
	methodsForCal: SelectSchemaValid;
	customLocationData: Location;
};

type Action = {
	updateSelected: ( Selected: State[ 'Selected' ] ) => void;
	mncm_selected: ( mncm: State[ 'mncm' ] ) => void;
	oaac_selected: ( oaac: State[ 'oaac' ] ) => void;
	hlm_selected: ( hlm: State[ 'hlm' ] ) => void;
	mfc_selected: ( mfc: State[ 'mfc' ] ) => void;
	cl_selected: ( customLocationSelected: State[ 'customLocationSelected' ] ) => void;

	updateOnSelected: ( OnSelect: State[ 'OnSelect' ] ) => void;
	updateSetMCMode: ( mcMode: State[ 'mcMode' ] ) => void;
	updateSetMethodsForCal: ( methodsForCal: State[ 'methodsForCal' ] ) => void;
	updateCustomLocationData: ( customLocationData: State[ 'customLocationData' ] ) => void;
	updateSetHighLittude: ( highLittude: State[ 'highLittude' ] ) => void;
	updateSetASRCAL: ( asrCal: State[ 'asrCal' ] ) => void;
	updateMonth: ( month: State[ 'month' ] ) => void;
};

// Create your store, which includes both state and (optionally) actions
export const useLocationStore = create< State & Action >()(
	devtools( ( set ) => ( {
		Selected: {
			name: '',
			meta: '',
		},
		customLocationSelected: {
			country: '',
			city: '',
			lat: '',
			lng: '',
			
		},
		mncm: {
			name: '',
			meta: '',
		},
		oaac: {
			name: '',
			meta: '',
		},
		hlm: {
			name: '',
			meta: '',
		},
		mfc: {
			name: '',
			meta: '',
		},
		OnSelect: {
			name: '',
			meta: '',
		},
		month: {
			id: '',
			'meta-key': '',
			value: [
				{
					name: '',
					method: '',
				},
			],
		},
		mcMode: {
			id: '',
			'meta-key': '',
			value: [
				{
					name: '',
					method: '',
				},
			],
		},
		asrCal: {
			id: '',
			'meta-key': '',
			value: [
				{
					name: '',
					method: '',
				},
			],
		},
		highLittude: {
			id: '',
			'meta-key': '',
			value: [
				{
					name: '',
					method: '',
				},
			],
		},
		methodsForCal: {
			id: '',
			'meta-key': '',
			value: [
				{
					name: '',
					method: '',
				},
			],
		},
		customLocationData:[],

		updateSelected: ( Selected ) => set( () => ( { Selected: Selected } ) ),
		updateMonth: ( month ) => set( () => ( { month: month } ) ),
		mncm_selected: ( mncm ) => set( () => ( { mncm: mncm } ) ),
		oaac_selected: ( oaac ) => set( () => ( { oaac: oaac } ) ),
		hlm_selected: ( hlm ) => set( () => ( { hlm: hlm } ) ),
		mfc_selected: ( mfc ) => set( () => ( { mfc: mfc } ) ),
		cl_selected: ( customLocationSelected ) => set( () => ( { customLocationSelected: customLocationSelected } ) ),
		updateOnSelected: ( OnSelect ) =>
			set( () => ( { OnSelect: OnSelect } ) ),
		updateSetMCMode: ( mcMode ) => set( () => ( { mcMode: mcMode } ) ),
		updateSetMethodsForCal: ( methodsForCal ) =>
			set( () => ( { methodsForCal: methodsForCal } ) ),
		updateSetASRCAL: ( asrCal ) => set( () => ( { asrCal: asrCal } ) ),
		updateSetHighLittude: ( highLittude ) =>
			set( () => ( { highLittude: highLittude } ) ),
		updateCustomLocationData: ( customLocationData ) =>
			set( () => ( { customLocationData: customLocationData } ) ),

	} ),
	{ name: 'storeLocation'} )
);
